module.exports = __webpack_public_path__ + "img/Midikids.51821480.jpg";